import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '@cnt-workspace/data-access';

@Component({
  selector: 'cnt-toast-host',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-host.component.html',
  styles: [`
    .cnt-toast { animation: cnt-toast-pop 220ms cubic-bezier(0.2, 0.8, 0.2, 1); }
    @keyframes cnt-toast-pop {
      from { opacity: 0; transform: translateY(-8px) scale(0.98); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }
    @media (prefers-reduced-motion: reduce) {
      .cnt-toast { animation: none; }
    }
  `],
})
export class ToastHostComponent {
  toasts = inject(ToastService);
}
